<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <!-- <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <multiselect v-model="tp_unidade"
                        :options="optionsTipoUnidade"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Cliente"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col> -->
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="tp_doc"
              :options="this.$parent.optionsTpTrecho"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Tipo do Documento"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Emissão Doc Inical"
              v-model="dt_emissao_ini"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Emissão Doc Final"
              v-model="dt_emissao_fim"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>

          <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_doc"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CTE/NFS</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="4" class="m-t-5px p-a-0">
            <multiselect
              v-model="transportadora"
              :options-limit="300"
              :limit="2"
              :limit-text="limitText"
              :options="optionsTransportadora"
              track-by="value"
              label="label"
              id="transportadora"
              :hide-selected="true"
              placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
              :searchable="true"
              :loading="isLoadingTransportadora"
              @search-change="listaTransportadora"
            ></multiselect>
          </b-col>

          <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="carga"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Carga</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_trecho"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N° do trecho</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="4" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="chave"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Chave CTE</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="status"
              :options="this.$parent.optionsStatus"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="status_doc_tranp"
              :options="this.$parent.optionsStatusDocTranp"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status Enviado ERP "
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="status_integracao"
              :options="this.$parent.optionsStatusIntegracao"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status Retorno ERP"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data Enviado"
              v-model="dt_enviado"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data Retorno"
              v-model="dt_retorno"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data Auditoria"
              v-model="dt_auditoria"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="4" class="m-t-5px p-a-0">
            <multiselect
                v-model="paramMotivoSelected"
                :options="this.$parent.optionsParamMotivo"
                track-by="parmot_id"
                label="label"
                :hide-selected="true"
                placeholder="Motivo"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
              ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { formatCNPJFromParts } from "../utils";

export default {
  data() {
    return {
      carga: "",
      dt_emissao_ini: "",
      dt_emissao_fim: "",
      num_doc: "",
      num_trecho: "",
      chave: "",
      status_doc_tranp: "",
      status_integracao: "",
      dt_enviado: "",
      dt_retorno: "",
      dt_auditoria: "",
      status: [],
      tp_doc: [],
      data_filter: [],
      isLoadingTransportadora: false,
      transportadora: [],
      optionsTransportadora: [],
      paramMotivoSelected: "",
      helpForm: new Form({ statusRecord: [], params: [], search: "" }),
    };
  },
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.data_filter = {
        carga: this.carga,
        num_doc: this.num_doc,
        num_trecho: this.num_trecho,
        dt_emissao_ini: this.dt_emissao_ini,
        dt_emissao_fim: this.dt_emissao_fim,
        status: this.status,
        tp_doc: this.tp_doc,
        chave: this.chave,
        status_doc_tranp: this.status_doc_tranp,
        status_integracao: this.status_integracao,
        dt_enviado: this.dt_enviado,
        dt_retorno: this.dt_retorno,
        dt_auditoria: this.dt_auditoria,
        transportadora: this.transportadora,
        param_motivo: this.paramMotivoSelected.value,
      };
      this.$events.fire("filter-set", this.data_filter);
    },
    resetFilter() {
      this.carga = ""; // clear the text in text input
      this.num_doc = "";
      this.num_trecho = " ";
      this.dt_emissao_ini = "";
      this.dt_emissao_fim = "";
      this.status = "";
      this.tp_doc = "";
      this.chave = "";
      this.status_doc_tranp = "";
      this.status_integracao = "";
      this.dt_enviado = "";
      this.dt_retorno = "";
      this.dt_auditoria = "";
      this.transportadora = "";
      this.paramMotivoSelected = "";
      this.$events.fire("filter-reset");
    },
    listaTransportadora(search) {
      if (!search || search.length < 3) return;

      this.isLoadingTransportadora = true;
      this.helpForm.search = search;
      this.helpForm.status = 1;

      this.helpForm
        .post("/api/pessoa/jsonlist/transportadora")
        .then((response) => {
          this.optionsTransportadora = [];
          ReturnApi.apply(response, this, true, false, false);

          if (response.items && response.items.length > 0) {
            response.items.forEach((obj) => {
              const cnpj = this.onFormataCnpj(
                obj.cnpj_base,
                obj.cnpj_filial,
                obj.cnpj_digito
              ).replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/, "$1.$2.$3/$4-$5");

              this.optionsTransportadora.push({
                label: `PJ -${obj.pessoa.cd} - ${obj.razao_social} - ${cnpj} - ${obj.inscricao_estadual}`,
                pessoa_id: obj.pessoa_id,
                value: obj.pessoa_id,
              });
            });
          }

          if (response.itemsF && response.itemsF.length > 0) {
            response.itemsF.forEach((obj) => {
              this.optionsTransportadora.push({
                label: "PF -" + obj.nome + " - " + obj.cpf,
                pessoa_id: obj.pessoa_id,
                value: obj.pessoa_id,
              });
            });
          }

          if (response.itemsE && response.itemsE.length > 0) {
            response.itemsE.forEach((obj) => {
              this.optionsTransportadora.push({
                label: "PE -" + obj.nome + " - " + obj.cd,
                pessoa_id: obj.pessoa_id,
                value: obj.pessoa_id,
              });
            });
          }

          this.isLoadingTransportadora = false;
        })
        .catch((errors) => {
          this.isLoadingTransportadora = false;
          new ReturnApi(errors, this);
        });
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>